import React, { useCallback, useEffect} from "react";
import { useDispatch } from "react-redux";
import t from "common/i18n";
import ResultImageGrid from "root/components/ResultImageGrid";
import { DIVERSITY_CATEGORIES, POPULAR_CATEGORIES, MEDIA_TYPES, MAIN_PAGE_CATEGORY_LABEL } from "../../data/consts";
import { useUI, useHomePageAssets } from "../../selectors";
import actions, { types as ats } from "../../actions";
import { CategoriesList, ListItem, CategoryHeader, CategorySubheader, CategoriesBox, GridBox } from "./CategoriesPage.styles";

const CategoryLink = ({ category, mediaType, handleSearch}) => {
	const navigateToCategory = useCallback(() => {
		handleSearch({ searchPhrase: category.phrase, mediaType });
	}, [handleSearch, category.phrase, mediaType]);

	return <ListItem onClick={navigateToCategory} data-test="pc-image">{category.name}</ListItem>;
};

const { [ats.RETRIEVE_HOME_PAGE_ASSETS]: retrieveHomePageAssetsAction } = actions.creators;

export default ({ handleSearch, onSelect }) => {
	const dispatch = useDispatch();
	const { isFiltersPanelOpen } = useUI();
	const { items, assetsInProgress, selected } = useHomePageAssets();

	useEffect(() => {
		dispatch(retrieveHomePageAssetsAction());
	}, [dispatch]);

	return (
		<CategoriesBox>
			<CategoryHeader>{t("istock.popular_categories")}</CategoryHeader>
			<CategorySubheader>{MAIN_PAGE_CATEGORY_LABEL}</CategorySubheader>
			<GridBox isFiltersPanelOpen={isFiltersPanelOpen} data-test="popular-categories-thumbnails">
				<ResultImageGrid
					images={isFiltersPanelOpen ? items.slice(0, 3) : items}
					selected={selected}
					selectionAction={onSelect}
					showProgressIndicator={assetsInProgress}
					isMultiple={false}
					itemWidth={isFiltersPanelOpen ? 170 : null}
					topBarRenderer={null}
				/>
			</GridBox>
			<CategoriesList data-test="popular-categories-list">
				{POPULAR_CATEGORIES.map(c => <CategoryLink category={c} handleSearch={handleSearch} mediaType={MEDIA_TYPES.IMAGES} key={c.name} />)}
			</CategoriesList>
			<CategoryHeader data-test="diversity-categories-list">{t("istock.diversity_categories")}</CategoryHeader>
			<CategoriesList>
				{DIVERSITY_CATEGORIES.map(c => <CategoryLink category={c} handleSearch={handleSearch} mediaType={MEDIA_TYPES.IMAGES} key={c.name} />)}
			</CategoriesList>
		</CategoriesBox>
	);
};
